import { type QuizDefinitionDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';

type Response = QuizDefinitionDto;

type Return = {
  error: Error | null;
  isGetting: boolean;
  quizDefinition: Response | undefined;
};

export const useGetQuizDefinition = (quizId?: string): Return => {
  const { restQuizApi } = useApiClient();
  const { t } = useTranslationWithPrefix('utils.errors');
  const { data, error, isFetching } = useQuery<Response>({
    enabled: !!quizId,
    queryFn: async () => {
      if (!quizId) {
        toast.error(t('unexpectedError'));
        throw new Error('Unexpected error - quizId is not defined');
      }
      const { data } = await restQuizApi.getQuizDefinition(quizId);
      return data;
    },
    queryKey: [QueryKeyEnum.GET_QUIZ_DEFINITION, quizId],
  });

  return {
    error,
    isGetting: isFetching,
    quizDefinition: data,
  };
};
